module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex p-2 mini"
  }, [_c('audio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "video",
    attrs: {
      "src": _vm.video.url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-2",
    staticStyle: {
      "width": "50px"
    }
  }, [(_vm.video.state !== 'playing') ? _c('button', {
    staticClass: "btn active",
    on: {
      "click": function($event) {
        _vm.play()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/btn_text_play.png"),
      "height": "35"
    }
  })]) : _c('button', {
    staticClass: "btn active",
    on: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/btn_text_pause.png"),
      "height": "35"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 w-100"
  }, [_c('progress-bar', {
    attrs: {
      "position": _vm.video.currentPos
    },
    on: {
      "seekTo": _vm.seekTo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-start pt-2 pb-2"
  }, [_c('div', [_c('button', {
    class: {
      'btn': true, 'active': _vm.reset
    },
    on: {
      "click": function($event) {
        _vm.seekToResetAction()
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reset),
      expression: "reset"
    }],
    attrs: {
      "src": require("../../assets/images/btn_text_back_to_start_on.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.reset),
      expression: "!reset"
    }],
    attrs: {
      "src": require("../../assets/images/btn_text_back_to_start_off.png")
    }
  })]), _vm._v(" "), _c('button', {
    class: {
      'btn': true, 'active': _vm.repeat && _vm.repeatIdx > -1
    },
    on: {
      "click": function($event) {
        _vm.repeatSingle()
      }
    }
  }, [(_vm.repeat && _vm.repeatIdx > -1) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_text_replay_on.png")
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.repeat || _vm.repeatIdx === -1) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_text_replay_off.png")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.slowAudioUrl) ? _c('button', {
    class: {
      'btn': true, 'active': _vm.video.slow
    },
    on: {
      "click": function($event) {
        _vm.slower()
      }
    }
  }, [(_vm.video.slow) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_text_slow_on.png")
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.video.slow) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_text_slow_off.png")
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    class: {
      'btn': true, 'active': _vm.repeat && _vm.repeatIdx === -1
    },
    on: {
      "click": function($event) {
        _vm.repeatAll()
      }
    }
  }, [(_vm.repeat && _vm.repeatIdx === -1) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_text_loop_on.png")
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.repeat || _vm.repeatIdx > -1) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/btn_text_loop_off.png")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.video.url.indexOf('blob:') > -1) ? _c('a', {
    staticClass: "btn active",
    attrs: {
      "download": "",
      "href": _vm.video.url
    }
  }, [_c('i', {
    staticClass: "fas fa-cloud-download-alt",
    attrs: {
      "aria-label": "download"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('span', {
    staticClass: "btn active"
  }, [_vm._v(_vm._s(_vm.duration(_vm.video.currentTime)) + " | " + _vm._s(_vm.duration(_vm.video.duration)))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21e7bbc1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/modules/MiniPlayer.vue
// module id = 713
// module chunks = 1